import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "tw:!inline-flex tw:items-center tw:justify-center tw:gap-2 tw:whitespace-nowrap tw:!rounded-full tw:text-sm tw:font-medium tw:transition-colors tw:focus-visible:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-brand-secondary tw:focus-visible:ring-offset-2 tw:disabled:pointer-events-none tw:disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "tw:bg-brand-primary tw:text-white tw:cursor-pointer tw:shadow tw:hover:bg-brand-primary-hover tw:min-w-24 tw:transition tw:duration-400",
        destructive:
          "tw:bg-red-500 tw:text-white tw:shadow-sm tw:cursor-pointer tw:hover:bg-red-600",
        outline:
          "tw:border tw:border-gray-300 tw:bg-white tw:shadow-sm tw:cursor-pointer tw:hover:bg-gray-100 tw:hover:text-gray-900 tw:transition tw:duration-400",
        secondary:
          "tw:bg-brand-secondary tw:text-white tw:cursor-pointer tw:shadow-sm tw:hover:bg-brand-secondary-hover tw:min-w-24 tw:transition tw:duration-400",
        ghost:
          "tw:bg-transparent tw:border-0 tw:hover:bg-gray-100 tw:hover:text-gray-900 tw:cursor-pointer",
        link:
          "tw:bg-transparent tw:border-0 tw:text-brand-secondary tw:underline-offset-4 tw:hover:underline tw:cursor-pointer",
        gradient:
          "tw:bg-gradient-to-r tw:from-brand-avatar-start tw:to-brand-avatar-end tw:text-white tw:cursor-pointer tw:shadow tw:hover:opacity-90 tw:min-w-24",
        success:
          "tw:bg-emerald-500 tw:text-white tw:shadow-sm tw:cursor-pointer tw:hover:bg-emerald-600",
      },
      size: {
        default: "tw:h-10 tw:px-4 tw:py-2",
        sm: "tw:h-8 tw:px-3 tw:text-xs",
        lg: "tw:h-12 tw:px-8 tw:text-base",
        icon: "tw:h-10 tw:w-10",
        "icon-sm": "tw:h-8 tw:w-8",
        "icon-lg": "tw:h-12 tw:w-12",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
